import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/home";
import Catalog from "./pages/catalog";
import Booking from "./pages/booking";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/booking" element={<Booking />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
